
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['year', 'month', 'hidden'];
  static values = { message: String };

  connect() {
    this.syncHiddenField();
  }

  onYearOrMonthChange() {
    const year = this.yearTarget.value;
    const month = this.monthTarget.value;
    if (!year || !month) {
      this.showMessage();
      return;
    }
    this.hideMessage();
    this.syncHiddenField();
  }

  showMessage() {
    if (this.hasMessageValue && this.messageValue) {
      this.displayMessage(this.messageValue);
    }
  }

  hideMessage() {
    this.displayMessage('');
  }

  displayMessage(msg) {
    let messageEl = this.element.querySelector('.error-message');
    if (!messageEl) {
      messageEl = document.createElement('p');
      messageEl.className = 'error-message';
      this.element.appendChild(messageEl);
    }
    messageEl.textContent = msg;
  }

  syncHiddenField() {
    const year = parseInt(this.yearTarget.value, 10);
    const month = parseInt(this.monthTarget.value, 10);

    if (isNaN(year) || isNaN(month)) {
      console.log('none!!');
      this.hiddenTarget.value = '';
      return;
    }

    const paddedMonth = String(month).padStart(2, '0');
    this.hiddenTarget.value = `${year}/${paddedMonth}`;
  }
}
